import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import ModalTipos from './ModalTipos';
import Alert from 'react-s-alert';
import store from '../../store';

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class TiposCalificaciones extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			tipos:[],
			isActive:false,
			key:'',
			tipo:'',
			estado:'',
			template:false
		}
		
		
		this.toggleModal=this.toggleModal.bind(this);
		this.tiposRef=database.ref().child('tipo_calificaciones');
		this.handleClick=this.handleClick.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.handleSubmit();
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
		
		
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
  
  
	handleClickClose(){		
		Alert.closeAll();
	}



	
	componentDidMount(){
		
		
		this.tiposRef.on('value',this.gotData,this.errData);
	}
	
	
	gotData=(data)=>{
		
		let tipos=[];
		let datatipos=data.val();

		if(datatipos!==null){
			
			let keys=Object.keys(datatipos);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				tipos.push({
					
					key:k,
					nombre:datatipos[k].nombre,
					estado:datatipos[k].estado
					
				})
				
			
			}
			this.setState({tipos:tipos});

		}
		
	}
	errData=(err)=>{
		
		
		
	}
	
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
		
	}
	
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	
	handleClick(row){
		
		
		this.setState({
			key:row.key,
			nombre:row.nombre,
			estado:row.estado
			
		})
		
		this.toggleModal();
	}
	
	
	handleSubmit(){
		
		
		this.tiposRef.child(this.state.key).update({
			
			estado:this.estado.value

		})

		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
		});
		
		this.toggleModal();
		
		
	}
		ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		
		return(
		
				<div className="container" onClick={this.ocultarMenu}>
				
					<h1 className="titulo">Tipos Calificaciones</h1>

						 {this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
					<ModalTipos/>
					<BootstrapTable data={ this.state.tipos }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre'  dataSort={true}  >Tipo</TableHeaderColumn>
							 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
					</BootstrapTable>
			
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
					

						<form method="POST" onSubmit={this.handleClickAlerta}>
					
						<h3>Editar tipo de calificación</h3>
						
						<hr/>
						
						
						
						
						<div className="form-group">
							<label>Tipo de calificación</label>
							<input type="text" className="form-control" required  placeholder="Tipo" autoComplete="off" defaultValue={this.state.nombre}
							 disabled="disabled" 
							/>						
						</div>
						
						
						<div className="form-group">
							<label>Estado</label>
							<select className="form-control" ref={input=>{this.estado=input}} defaultValue={this.state.estado}>
								<option>Activo</option>
								<option>Inactivo</option>
							</select>
						</div>
						
						
						
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>	
						
						
					</Modal>

			
					
			
				</div>
		
		);
		
		
	}
	
	
}

export default TiposCalificaciones;


// WEBPACK FOOTER //
// ./src/Components/Calificaciones1/TiposCalificaciones.js